import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiEye, FiLogOut } from 'react-icons/fi';
import { logout } from '../../store/slices/authSlice';
import { isImpersonating } from '../../services/api';

function ImpersonationBanner() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  if (!user?.impersonation || !isImpersonating()) return null;

  const exit = () => {
    dispatch(logout());
    navigate('/login');
  };

  const initials = `${(user.firstName || '')[0] || ''}${(user.lastName || '')[0] || ''}`.toUpperCase();

  return (
    <div className="impersonation-banner" role="alert">
      <div className="impersonation-banner__info">
        <span className="impersonation-banner__badge" aria-hidden="true">
          <FiEye />
          <span className="impersonation-banner__pulse" />
        </span>
        <span className="impersonation-banner__avatar" aria-hidden="true">{initials}</span>
        <span className="impersonation-banner__texts">
          <span className="impersonation-banner__title">
            {t('impersonation.bannerTitle', {
              target: `${user.firstName} ${user.lastName}`,
            })}
          </span>
          <span className="impersonation-banner__subtitle">
            {t('impersonation.bannerBy', { owner: user.impersonation.impersonatorName })}
          </span>
        </span>
      </div>
      <button type="button" className="impersonation-banner__exit" onClick={exit}>
        <FiLogOut /> {t('impersonation.exit')}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
